import {Component, HostListener, OnDestroy, OnInit} from "@angular/core";
import {
  DposUser,
  MembershipControllerService,
  Merchant,
  OrderControllerService,
  OrderReq,
  PagePosItemVsMerchant, Payment,
  PaymentControllerService, PosItem,
  PosItemCategory, PosItemVarianceModel,
  PosItemVsMerchant,
  TableMerchant,
  TableMerchantControllerService,
  TaxConfig
} from "../../@services/gen";
import {TdDialogService} from '@covalent/core/dialogs';
import {PosItemDialogComponent} from './pos-product-dialog/pos-item-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';
import {PosItemService} from '../../@services/pos-item.service';
import {TaxService} from '../../@services/tax.service';
import {OrderService} from '../../@services/order.service';
import {PosDiscountDialogComponent} from './pos-discount-dialog/pos-discount-dialog.component';
import {Subscription, take, tap} from 'rxjs';
import {NotificationService} from '../../@services/notification.service';
import {CalculatorComponent} from '../../@components/calculator/calculator.component';
import { lcdScreen, secondScreen } from "../../@services/utils";
import {PaymentService} from '../../@services/payment.service';
import {LocalstorageService} from '../../@services/localstorage.service';
import {Order} from 'src/app/@services/gen/model/order';
import {OrderItem} from '../../@services/gen/model/orderItem';
import {AuthService} from '../../@services/auth.service';
import {MembershipSearchDialogComponent} from '../membership/membership-search-dialog/membership-search-dialog.component';
import OrderStatusEnum = Order.OrderStatusEnum;
import KitchenOrderStatusEnum = Order.KitchenOrderStatusEnum;
import {BarcodeScannerService} from '../../@services/barcode-scanner.service';
import {ExtendedOrder, ExtendedOrderItems} from './pos-split-bill-dialog/pos-split-bill-dialog.component';
import {PosOpenItemDialogComponent} from "./pos-open-item-dialog/pos-open-item-dialog.component";
import { FeatureService } from "../../@services/feature.service";
import {PosPaxNoDialogComponent} from "./pos-pax-no-dialog/pos-pax-no-dialog.component";
import {ManagerAuthService} from "../../@services/manager-auth.service";
import OrderTypeEnum = OrderItem.OrderTypeEnum;
import {MatDialog} from "@angular/material/dialog";
import {ChooseOrderTypeDialogComponent} from "./choose-order-type-dialog/choose-order-type-dialog.component";

@Component({
  selector: 'app-pos',
  templateUrl: './pos.component.html',
  styleUrls: ['./pos.component.scss'],
})
export class PosComponent implements OnInit {
  order: ExtendedOrder;
  selectedCategory: PosItemCategory = {id: 0};
  posCategories: PosItemCategory[] = [];
  posItems?: PosItemVsMerchant[] = [];
  filteredPosItems: PosItemVsMerchant[] = [];
  merchant: Merchant = {};
  user: DposUser = {};
  table: TableMerchant = {};
  loading = {
    submitting: false,
    holding: false,
  };
  taxRates: {tax1Config: TaxConfig; tax2Config: TaxConfig};
  orderQuantity: number = 0;
  message: string = 'FNB';
  isMobile: boolean = false;
  isCheckout: boolean = false;
  isMembershipSettingExist = false;
  isTrackPax = false;
  allowOpenItem: boolean = false;
  activeTab: OrderTypeEnum = OrderTypeEnum.DineIn; // Default to Dine In

  scannedData: string = '';
  private subscription: Subscription;

  constructor(
    private customPosItemService: PosItemService,
    private orderService: OrderControllerService,
    private paymentService: PaymentControllerService,
    private ns: NotificationService,
    private tableService: TableMerchantControllerService,
    private ds: TdDialogService,
    private ls: LocalstorageService,
    private route: ActivatedRoute,
    private router: Router,
    private customTaxService: TaxService,
    private customOrderService: OrderService,
    private posItemService: PosItemService,
    private membershipControllerService: MembershipControllerService,
    private featureService: FeatureService,
    private managerAuthService: ManagerAuthService,
    private customAuthService: AuthService,
    private dialog: MatDialog
  ) {
    this.checkIsMobile();
  }

  ngOnInit(): void {
    this.merchant = this.ls.getMerchant();
    this.user = this.customAuthService.getUser();
    this.taxRates = this.customTaxService.getTaxRates();

    if(this.featureService.isFeatureEnabled('allowOpenItem')){
      this.allowOpenItem = true;
    } else {
      this.allowOpenItem = false;
    }


    this.route.queryParams.subscribe((qp) => {
      if (qp['tableId']) {
        this.tableService
          .getTableMerchantPost({
            id: +qp['tableId'],
          })
          .subscribe((res) => {
            this.table = res;

            if (qp['orderId']) {
              this.orderService
                .getOrderPost({
                  id: +qp['orderId'],
                })
                .subscribe((o) => {
                  this.order = o as ExtendedOrder;
                  this.getNoPax();
                  this.calculateOrderTotalAmount();
                });
            } else {
              this.initOrder();
            }

            if(this.table){
              if (
                this.table.name.toLowerCase().includes('ta') ||
                this.table.name.toLowerCase().includes('take away') ||
                this.table.name.toLowerCase().includes('bungkus')
              ) {
                this.activeTab = OrderTypeEnum.TakeAway;
              } else {
                this.activeTab = OrderTypeEnum.DineIn;
              }
            }


            this.load();
            this.getMembershipSetting();
          });
      }
    });

    // this.subscription = this.barcodeScannerService.getScanData().subscribe((data) => {
    //   this.scannedData = data;
    //   this.scanBarcode(this.scannedData);
    // });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkIsMobile();
  }

  private checkIsMobile() {
    this.isMobile = window.innerWidth < 768; // You can adjust the threshold as needed
  }


  load() {
    this.loadPosItems();
  }

  private loadPosItems() {
    let dialogRef = this.ns.showNotification({
      message: 'Loading...',
      icon: 'fa fa-sync',
      manualClose: true,
    });

    this.customPosItemService
      .getCachePagedPosItemVsMerchant(this.merchant.id)
      .pipe(tap((value) => {}))
      .subscribe(
        (res) => {
          if (res && res.content) {
            dialogRef.close();

            this.posItems = res.content;

            this.filteredPosItems = res.content;

            this.populateCategorys(res);
            this.changeCategory(this.posCategories[0].id);
          } else {
            dialogRef.close();
          }
        },
        (error) => {
          dialogRef.close();
        }
      );
  }

  private populateCategorys(res: PagePosItemVsMerchant) {
    // unique categories
    let posItemCategories = res.content.map((x) => x.posItem.posItemCategory);
    for (let posItemCategory of posItemCategories) {
      if (this.posCategories.findIndex((x) => x.id === posItemCategory.id) == -1) {
        this.posCategories.push(posItemCategory);
      }
    }
  }

  changeCategory(catId: number) {
    this.selectedCategory.id = catId;
    this.filteredPosItems = this.posItems.filter((x) => x.posItem.posItemCategory.id === catId);
  }

  searchMenu(value: any) {
    if (!value) {
      this.filteredPosItems = this.posItems.filter(
        (x) => this.selectedCategory.id === 0 || x.posItem.posItemCategory.id === this.selectedCategory.id
      );
    } else {
      this.filteredPosItems = this.posItems.filter(
        (x) =>
          x?.posItem?.name.toLowerCase().includes(value.toLowerCase()) ||
          x.barcode?.toLowerCase().includes(value.toLowerCase()) ||
          (x.posItem?.skuNo && x.posItem?.skuNo.toLowerCase().includes(value.toLowerCase()))
      );
    }
  }

  addItem(item: PosItemVsMerchant) {
    if (item.posItem.variance) {
      item.posItem.varianceModel = [...JSON.parse(item.posItem.variance)];
    }

    if (this.activeTab === OrderTypeEnum.TakeAway) {
      if(item.takeAwayPrice && item.takeAwayPrice > 0){
        if(item.posItem.varianceModel){
          item.posItem.varianceModel.push(this.setTakeWayPrice(item));
        } else {
          item.posItem.varianceModel = [];
          item.posItem.varianceModel.push(this.setTakeWayPrice(item));
        }
      }
    } else {
      const index = item.posItem.varianceModel.findIndex(x => x.title === 'Prepare');
      if (index !== -1) {
        item.posItem.varianceModel.splice(index, 1);
      }
    }

    if (item.posItem.varianceModel.length > 0 || item.price == 0) {

      let width = '90%';
      let height = '90%';
      let minHeight = null;
      let minWidth = null;

      if (this.isMobile) {
        width = '100vw';
        height = '100vh';
        minHeight = '100vh';
        minWidth = '100vw';
      }

      this.ds
        .open(PosItemDialogComponent, {
          width: width,
          height: height,
          disableClose: true,
          minHeight: minHeight,
          minWidth: minWidth,
          panelClass: 'no-padding-dialog',
          data: {
            orderItem: {
              name: item.posItem.name,
              price: item.price,
              skuNo: item.posItem.skuNo,
              quantity: 1,
              subtotal: item.price,
              discountAmount: 0,
              total: 0,
              posItemVsMerchant: item,
              averageCost: item.averageCost ?? 0,
              deleted: false,
            } as ExtendedOrderItems,
            activeTab: this.activeTab
          },
        })
        .afterClosed()
        .subscribe((res: ExtendedOrderItems) => {
          if (res) {

            // if (this.activeTab === OrderTypeEnum.TakeAway) {
            //   if(res.varianceModel){
            //     res.varianceModel.push(this.setTakeWayPrice(item));
            //   } else {
            //     res.varianceModel = [];
            //     res.varianceModel.push(this.setTakeWayPrice(item));
            //   }
            // }
            this.updateOrder(res);
          }
        });
    } else {
      let res = {
        name: item.posItem.name,
        price: item.price,
        skuNo: item.posItem.skuNo,
        quantity: 1,
        subtotal: item.price,
        discountAmount: 0,
        total: 0,
        posItemVsMerchant: item,
        averageCost: item.averageCost ?? 0,
        deleted: false,
      } as ExtendedOrderItems;

      // if (this.activeTab === OrderTypeEnum.TakeAway) {
      //   if(res.varianceModel){
      //     res.varianceModel.push(this.setTakeWayPrice(item));
      //   } else {
      //     res.varianceModel = [];
      //     res.varianceModel.push(this.setTakeWayPrice(item));
      //   }
      // }

      console.log(res);
      this.updateOrder(res);

    }
  }

  setTakeWayPrice(item: PosItemVsMerchant): PosItemVarianceModel{
    let varianceModel: PosItemVarianceModel = null;

    console.log(item);
      varianceModel = {
        mandatory: true,
        maxPick: 1,
        options: [],
        position: 0,
        title: 'Prepare',
        type: 'optional',
      };

      varianceModel.options = [];

      varianceModel.options.push({
        active: true,
        defaultSelection: true,
        name: 'TAKE AWAY',
        position: 0,
        price: item.takeAwayPrice ? item.takeAwayPrice : 0,
        selected: false,
      });

    return varianceModel;
  }

  editItem(orderItem: OrderItem) {
    let item = orderItem.posItemVsMerchant;
    if (item.posItem.variance) {
      item.posItem.varianceModel = [...JSON.parse(item.posItem.variance)];
    }

    let width = '90%';
    let height = '90%';
    let minHeight = null;
    let minWidth = null;

    if (this.isMobile) {
      width = '100vw';
      height = '100vh';
      minHeight = '100vh';
      minWidth = '100vw';
      // this.isCheckout = false;
    }

    this.ds
      .open(PosItemDialogComponent, {
        width: width,
        height: height,
        disableClose: true,
        minHeight: minHeight,
        minWidth: minWidth,
        data: {
          orderItem: orderItem,
        },
      })
      .afterClosed()
      .subscribe((res: ExtendedOrderItems) => {
        if (res) {
          this.updateOrder(res, true);

          if (this.featureService.isFeatureEnabled('lcdScreen') && !this.isMobile) {
            lcdScreen([
              res.name,
              res.netAmount.toFixed(2)
            ])
          }

        }
      });
  }

  removeItem(index) {
    const visibleItems = this.order.orderItems.filter(x => !x.deleted);
    const item = visibleItems[index];

    if (item) {
      item.deleted = true;
      item.kitchenStatus = KitchenOrderStatusEnum.Cancelled;
      this.order.orderItems = [...this.order.orderItems]; // Trigger change detection
    }

    this.getFilteredItems();
    this.calculateOrderTotalAmount();
    this.updateSecondScreen();
  }

  updateOrder(orderItem: ExtendedOrderItems, isUpdate: boolean = false) {
    orderItem.prepareType = this.activeTab;
    let generatedId = orderItem.skuNo + orderItem.variance + orderItem.prepareType + orderItem.instructions;
    orderItem['generatedId'] = generatedId;

    let index = this.order.orderItems.findIndex((x) => x['generatedId'] === generatedId && !x.deleted);
    if (index > -1) {
      if (isUpdate) {
        this.order.orderItems[index].quantity = orderItem.quantity;
      } else {
        this.order.orderItems[index].quantity += orderItem.quantity;
      }
    } else {
      this.order.orderItems = [orderItem, ...this.order.orderItems];
    }

    this.calculateOrderTotalAmount();

    this.updateLcdScreen(index > -1 ? this.order.orderItems[index] : orderItem);
    this.updateSecondScreen();
  }


  calculateOrderTotalAmount() {
    for (let orderItem of this.order.orderItems) {
      orderItem.toBePaidQuantity = orderItem.quantity;
    }
    const calculatedValues = this.customOrderService.calculateOrderValues([this.order]);
    this.order.subtotal = calculatedValues.subtotal;
    this.order.tax1Amount = calculatedValues.tax1Amount;
    this.order.tax2Amount = calculatedValues.tax2Amount;
    this.order.totalAmount = calculatedValues.totalAmount;
    this.order.roundingAmount = calculatedValues.roundingAmount;
    this.order.netAmount = calculatedValues.netAmount;
    this.order.averageCost = +calculatedValues.averageCost;
    this.order.discountItemAmount = +calculatedValues.discountItemAmount;
    this.orderQuantity = +calculatedValues.quantity;
    this.order.inclusiveTax = +calculatedValues.inclusiveTax;

  }

  clearCart() {
    this.order.orderItems = [];
    this.calculateOrderTotalAmount();
    this.updateSecondScreen();
  }

  hold() {
    this.loading.holding = true;
    this.orderService.upsertOrderPost({order: this.order}).subscribe((res) => {
      this.ns.showNotification({message: 'Order has been hold', icon: 'fa fa-info'});
      this.navigateToHome();
      this.loading.holding = false;
    });
  }

  submitOrder() {
    console.log(this.order);
    this.loading.submitting = true;
    let dialogRef = this.ns.showNotification({
      message: this.order?.id > 0 ? 'Updating order...' : 'Submitting order...',
      icon: 'fa fa-info',
      manualClose: true,
    });

    console.log(this.order);
    const order = {
      ...this.order,
      kitchenOrderStatus: KitchenOrderStatusEnum.Confirmed,
      orderStatus: OrderStatusEnum.Unpaid,
    };

    console.log(this.order);
    console.log(order);

    this.orderService.upsertOrderPost({order: order}).subscribe((res) => {
      dialogRef.close();

      console.log(res);
      if (this.order.id > 0) {

        this.navigateToHome();
      } else {
        this.loading.submitting = false;

        res.orderItems.map((x) => {
          x.order = {
            id: res.id,
          };
        });

        const updatedOrder = {
          ...res,
          kitchenOrderStatus: KitchenOrderStatusEnum.Confirmed,
          orderStatus: OrderStatusEnum.Unpaid,
        };

        this.navigateToHome();

        // this.upsertOrderAndNavigate(updatedOrder);
      }

      if (this.merchant.natureOfBusiness === 'FNB') {
        this.message = 'Sending order to kitchen';
      } else {
        this.message = 'Processing';
      }

      let dialogRef2 = this.ns.showNotification({
        message: this.message,
        manualClose: true,
        icon: 'fa fa-sync',
      });

      setTimeout(() => {
        dialogRef2.close();
      }, 500);
    });
  }

  private upsertOrderAndNavigate(order: any) {
    this.orderService.upsertOrderPost({order}).subscribe(() => {
      this.navigateToHome();
    });
  }

  private navigateToHome() {
    this.router.navigate(['/'], {
      queryParams: {
        tableId: this.table.id,
      },
    });
  }

  private initOrder() {
    this.order = {
      id: 0,
      orderItems: [],
      orderType: this.table.orderType,
      orderStatus: OrderStatusEnum.New,
      merchant: {id: this.merchant.id},
      tableCustomer: {
        id: this.table.id,
      },
    } as ExtendedOrder;

    this.getNoPax();
    this.calculateOrderTotalAmount();
  }

  addQty(item: OrderItem) {
    let index = this.order.orderItems.findIndex((x) => x['generatedId'] === item['generatedId']);

    if (index > -1) {
      this.order.orderItems[index].quantity += 1;
    }

    this.calculateOrderTotalAmount();
    this.updateLcdScreen(this.order.orderItems[index]);
    this.updateSecondScreen();
  }

  minusQty(item: OrderItem) {
    let index = this.order.orderItems.findIndex((x) => x['generatedId'] === item['generatedId']);
    if (index > -1) {
      if (this.order.orderItems[index].quantity > 1) {
        this.order.orderItems[index].quantity -= 1;
      }
    }

    this.calculateOrderTotalAmount();
    this.updateLcdScreen(this.order.orderItems[index]);
    this.updateSecondScreen();
  }

  refreshMenu() {
    this.customPosItemService.cachePosItemVsMerchant$ = null;
    this.filteredPosItems = [];
    this.posCategories = [];
    this.load();
  }

  editDiscount(item: OrderItem) {
    if(this.featureService.isFeatureEnabled('discountPermission')){
      this.checkDiscountPermission(item);
    } else {
      item.discountBy = this.user?.username;
      this.discountProcess(item)
    }
  }

  discountProcess(item: OrderItem) {
    let minHeight = null;
    let minWidth = '600px';

    if (this.isMobile) {
      minHeight = '100vh';
      minWidth = '100vw';
    }

    this.ds
      .open(PosDiscountDialogComponent, {
        minWidth: minWidth,
        minHeight: minHeight,
        data: {
          orderItem: item,
        },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          item.discountRemarks = res?.discountRemarks;
          item.discountAmount = res?.cashDiscount || 0;
          item.discountPercentage = res?.discountPercentage || 0;
          this.calculateOrderTotalAmount();
          this.updateLcdScreen(item);
          this.updateSecondScreen();
        }
      });
  }

  private checkDiscountPermission(item: OrderItem) {
    this.managerAuthService.requireManagerAuth({ requireRemark: true }).subscribe(result => {
      if (result && result.success) {
        item.discountRemarks = result.remark;
        item.discountBy = result.username;
        this.discountProcess(item);
      }
    });
  }

  editPrice(item: OrderItem) {
    let price = item?.posItemVsMerchant?.price;
    let variancePrice: number = 0;
    if (item.varianceModel && item.varianceModel.length > 0) {
      variancePrice = item.varianceModel
        .flatMap((x) => x.options)
        .reduce((previousValue, currentValue) => previousValue + currentValue.price, 0);
    }
    let totalPrice = price + variancePrice;

    this.ds
      .open(CalculatorComponent, {
        data: {
          title: `Original price: ${totalPrice?.toFixed(2)} per unit. <br> Enter new price : <br>`,
        },
      })
      .afterClosed()
      .subscribe((val) => {
        if (val) {
          if (val !== '0.00') {
            item['overridePrice'] = true;
            item.price = val;
            this.calculateOrderTotalAmount();
            this.updateSecondScreen();
          } else if (val == '0.00') {
            this.ds.openAlert({
              message: 'Price cannot be 0',
            });
          }
        }
      });
  }

  private updateLcdScreen(orderItem: OrderItem) {
    if (this.featureService.isFeatureEnabled("lcdScreen") && !this.isMobile) {
      lcdScreen([
        orderItem.name,
        (orderItem.subtotal - orderItem.discountAmount).toFixed(2)
      ]);
    }
  }

  private updateSecondScreen() {

    if (!this.isMobile) {
      secondScreen({
        backgroundUrl: this.merchant.secondScreenBanner,
        merchantName: this.merchant.storeName || this.merchant.companyName,
        merchantLogoUrl: this.merchant['merchantLogoSmall'],
        orderItems: this.order.orderItems.filter((oi) => !oi.deleted),
        payment: undefined,
        discountAmount: this.order.discountAmount,
        discountItemAmount: this.order.discountItemAmount,
        netAmount: this.order.netAmount,
        quantity: this.orderQuantity,
        roundingAmount: this.order.roundingAmount,
        subtotal: this.order.subtotal,
        tax1Amount: this.order.tax1Amount,
        tax2Amount: this.order.tax2Amount,
        totalAmount: this.order.totalAmount,
      });
    }
  }

  searchCustomer() {
    let minHeight = null;
    let minWidth = '50%';

    if (this.isMobile) {
      minHeight = '100vh';
      minWidth = '90%';
    }

    this.ds
      .open(MembershipSearchDialogComponent, {
        minWidth: minWidth,
        data: {
          customer: this.order.membership || {},
        },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((customer) => {
        if (customer) {
          this.order.membership = {...customer};
        }
      });
  }

  removeCustomer() {
    this.ds
      .openConfirm({
        title: 'Remove Customer',
        message: 'Remove Customer?',
      })
      .afterClosed()
      .subscribe((confirmed) => {
        if (confirmed) {
          this.order.membership = null;
        }
      });
  }

  scanBarcode(barcode) {
    this.posItemService.getPosItemByBarcode(barcode, this.posItems).subscribe((item) => {
      this.addItem(item);
    });
  }

  openItem(){
    this.ds
      .open(PosOpenItemDialogComponent, {
        width: '90%',
        height: '90%',
        data: {
          merchant: this.merchant,
        },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((res: any) => {

        if (res.data && res.data.id > 0) {

          const posItem: PosItem = res?.data?.posItem;
          const posItemVsMerchant: PosItemVsMerchant = res?.data?.posItem?.posItemVsMerchant;

          posItemVsMerchant.posItem.posItemVsMerchant = null;

          this.addItem(posItemVsMerchant);
        }
      });
  }

  getQuantity(pivm: PosItemVsMerchant): any {
    const qty = this.order?.orderItems
      ?.filter((x) => x.posItemVsMerchant.id === pivm.id && x.deleted == false)
      .reduce((a, b) => {
        return (a += b.quantity);
      }, 0);
    if (qty > 0) {
      return qty;
    }
    return '';
  }

  getQuantityAllItem(): any {
    let quantity = 0;
    this.order?.orderItems.forEach((x) => {
      if(x.deleted == false){
        quantity = quantity + x.quantity;
      }
    });

    return quantity;
  }

  checkout(evt){
    evt.preventDefault()
    this.isCheckout = true;
  }

  getMembershipSetting(){
    this.membershipControllerService.getMembershipSettingPost(this.merchant.id).subscribe(res => {

      if(res){
        this.isMembershipSettingExist = true;
      } else {
        this.isMembershipSettingExist = false;
      }
    })
  }

  getNoPax(isClick?){
    let minHeight = null;
    let minWidth = '600px';

    if (this.isMobile) {
      minHeight = '30vh';
      minWidth = '90vw';
    }

      if (this.featureService.isFeatureEnabled('paxNoModule')) {
        this.isTrackPax = true;

        if(!this.order?.paxNo || isClick){
          this.ds
            .open(PosPaxNoDialogComponent, {
              width: minWidth,
              height: minHeight,
              data: {
                paxNo: this.order?.paxNo,
              },
            })
            .afterClosed()
            .pipe(take(1))
            .subscribe((res: any) => {
              if (res) {
                if(!res.paxNo){
                  this.order.paxNo = 0;
                } else {
                  this.order.paxNo = res.paxNo;
                }
              }
            });
        }
      }
    }

  // Function to filter items based on the active tab (orderType)
  getFilteredItems(): any[] {

    let orderItems = this.order?.orderItems.filter(item => item.prepareType === this.activeTab && !item.deleted);

    return orderItems;
  }

  // Function to switch the tab
  setActiveTab(tab: OrderTypeEnum): void {
    this.activeTab = tab;
  }

  getItemCount(orderType: OrderTypeEnum): number {
    return this.order?.orderItems.filter(item => item.prepareType === orderType && !item.deleted).length;
  }

  returnCheckoutPage(){
    this.isCheckout = false;
  }

  openOrderTypeDialog(item): void {
    this.activeTab = OrderTypeEnum.DineIn;
    const dialogRef = this.dialog.open(ChooseOrderTypeDialogComponent, {
      width: '400px',
      data: {
        orderType: this.activeTab,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Handle the selected order type
        this.activeTab = result;
        this.addItem(item)
      }
    });
  }
  protected readonly OrderTypeEnum = OrderTypeEnum;
}
